import getContextMenuFolders from '../actions/helpers/getContextMenuFolders';
import { mutator } from 'satcheljs';
import initializeInboxRulesFolderStore from '../actions/actionCreators/initializeInboxRulesFolderStore';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import folderStore, { getEffectiveFolderDisplayName } from 'owa-folders';
import store from '../store/store';

mutator(initializeInboxRulesFolderStore, actionMessage => {
    const junkFolderId = folderNameToId('junkemail');
    store.contextMenuFolders = getContextMenuFolders();
    store.junkFolderDisplayName = getEffectiveFolderDisplayName(
        folderStore.folderTable.get(junkFolderId)
    );
});
